import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Text from "../../styleguide/Text";

function CategoryHeader({
  title,
  isRequired = true,
}: {
  title: string;
  isRequired?: boolean;
}) {
  return (
    <label className="mb-4 flex items-center text-[1.15rem] font-semibold text-gray-900">
      <Text
        variant="h2"
        component="span"
        className="inline-flex items-center gap-1">
        {title}
        {isRequired && (
          <span className="text-danger" aria-hidden="true">
            *
          </span>
        )}
      </Text>
      {isRequired && (
        <InfoOutlinedIcon
          className="ml-2 text-muted"
          sx={{ fontSize: "0.9rem" }}
          titleAccess="Camp obligatoriu"
        />
      )}
    </label>
  );
}

export default CategoryHeader;
